import { createMigration } from './utils';

export const migrationTo9_166 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            // we're only looking for lower third scenes that are in a talking_head_insert scene category
            if (scene.get('sceneCategory') !== 'talking_head_insert') {
                return;
            }

            if (scene.get('sceneDesign').includes('LowerThird')) {
                map.get('children', []).forEach((asset, c) => {
                    if (asset.get('classType') === 'GraphicStyleTextAsset') {
                        map.setIn(['children', c, 'animateOutBehaviour'], 'always');
                    }
                });
            }
        });
    },
});
